/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
console.log("custom.js loaded: variant-change debugger active");

document.addEventListener("change", function(event) {
    const target = event.target;
    if (!target) {
        return;
    }

    // We care about variant swatches / radios inside the product form
    const isVariantSwatch =
        target.matches("input[type='radio'][data-single-option-selector]") ||
        (target.closest && target.closest("[data-product-form]"));

    if (!isVariantSwatch) {
        return;
    }

    console.log("Detected swatch/radio variant selection:", target);

    // Get the REAL Shopify variant ID from the hidden input
    const hiddenVariantInput = document.querySelector("form[data-product-form] input[name='id']");
    const realVariantId = hiddenVariantInput ? hiddenVariantInput.value : null;

    console.log("REAL variant ID:", realVariantId);

    if (!realVariantId) {
        return;
    }

    // Build a rich payload so we cover multiple expectations
    const variantPayload = {
        id: realVariantId,
        variantId: realVariantId,
        variant_id: realVariantId,
        variant: {
            id: realVariantId
        }
    };

    // Helper to dispatch on both document and window
    function fireEvent(eventName) {
        const eventObject = new CustomEvent(eventName, { detail: variantPayload });

        document.dispatchEvent(eventObject);
        window.dispatchEvent(eventObject);

        console.log("Event dispatched:", eventName, "with payload:", variantPayload);
    }

    // Fire multiple common event names used by apps
    fireEvent("variant:changed");
    fireEvent("variantChange");
    fireEvent("product:variant-change");
});

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
